<template>
    <v-card class="ma-3 pa-5">
        <h4>Error messages</h4>
        <div class="mb-8" v-for="errorMessage in errorMessages" :key="errorMessage.id">
            <h5 class="ml-2 mt-2">{{ errorMessage.title }}</h5>
            <v-row class="mx-2 mt-3">
                <v-text-field v-model="errorMessage.locale.et" class="mr-3" label="Text ET" type="text" />
                <v-text-field v-model="errorMessage.locale.en" class="mr-3" label="Text EN" type="text" />
                <v-text-field v-model="errorMessage.locale.fi" class="mr-3" label="Text FI" type="text" />
                <v-text-field v-model="errorMessage.locale.lt" class="mr-3" label="Text LT" type="text" />

                <v-select
                    :items="errorMessage.probes"
                    item-text="name"
                    item-value="probeId"
                    v-model="errorMessage.active_probes"
                    label="Probes"
                    hint="Pick stations"
                    multiple
                    return-object
                >
                    <template v-slot:selection="{ item, index }">
                        <span v-if="index === 0">{{ item.name }} </span>
                        <span v-if="index === 1" class="grey--text text-caption ml-1"
                            >(+ {{ errorMessage.active_probes.length - 1 }} others)
                        </span>
                    </template>
                    <template v-slot:prepend-item>
                        <v-list-item ripple @mousedown.prevent @click="handleSelectAllClick(errorMessage)">
                            <v-list-item-action>
                                <v-icon color="indigo darken-4">
                                    {{ toggleAllIcon(errorMessage) }}
                                </v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Select All
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                    </template>
                </v-select>
                <v-btn
                    v-if="
                        user.role === 'super_admin' ||
                            user.user_permissions.station_messages.includes(PermissionsConstants.EDIT)
                    "
                    class="mt-4 ml-4"
                    color="primary"
                    small
                    @click="editErrorMessage(errorMessage)"
                    >Save</v-btn
                >
            </v-row>
        </div>
    </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { PermissionsConstants } from '../../permissions'

export default {
    name: 'CreateStationMessageCard',
    computed: {
        PermissionsConstants() {
            return PermissionsConstants
        },
        ...mapState('stationMessage', ['errorMessages']),
        ...mapState('auth', ['user']),
    },
    async mounted() {
        await this.getStationErrorMessages()
    },
    methods: {
        ...mapActions('stationMessage', ['getStationErrorMessages', 'updateStationMessage']),
        async editErrorMessage(errorMessage) {
            await this.updateStationMessage(errorMessage)
        },

        handleSelectAllClick(errorMessage) {
            if (errorMessage.active_probes.length === errorMessage.probes.length) {
                errorMessage.active_probes = []
            } else {
                errorMessage.active_probes = errorMessage.probes
            }
        },
        toggleAllIcon(errorMessage) {
            if (errorMessage.active_probes.length === errorMessage.probes.length) return 'mdi-close-box'
            if (errorMessage.active_probes.length > 0) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
    },
}
</script>

<style scoped></style>
